import { render, staticRenderFns } from "./dashboardPage.vue?vue&type=template&id=ab410586&scoped=true&"
import script from "./dashboardPage.vue?vue&type=script&lang=js&"
export * from "./dashboardPage.vue?vue&type=script&lang=js&"
import style0 from "./dashboardPage.vue?vue&type=style&index=0&id=ab410586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab410586",
  null
  
)

export default component.exports